import React from 'react';

import { useStepperContext } from 'lib/context/StepperContext/StepperContext';

import useOrchestratorSubmission from '../lib/useOrchestratorSubmission';

const withWizardStep = (WrappedComponent) => {
  const WithWizardStep = (props) => {
    const { orchestratorData, goNext } = useStepperContext();

    const { mutateAsync: mutateOrchestratorData, isPending: orchestratorLoading } =
      useOrchestratorSubmission({
        orchestratorData,
        onNext: goNext,
        invalidateQueryKey: ['wizard-instance', 'practice', 'wizard-overview']
      });

    return (
      <WrappedComponent
        {...props}
        orchestratorLoading={orchestratorLoading}
        mutateOrchestratorData={mutateOrchestratorData}
      />
    );
  };

  WithWizardStep.displayName = `withWizardStep(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithWizardStep;
};

export default withWizardStep;
